const extractInnerHtmlFromText = (text) => {
  const span = document.createElement("span");
  span.innerHTML = text;
  return span.textContent || span.innerText;
};

export const buildCardsData = (template, oldData) => {
  if (!oldData?.cards?.length) return template;

  const cards = [];
  oldData.cards.forEach((card) => {
    const { title, text, label, linkText, link, newTab, tabId, image, icon } =
      card;

    const newCard = {
      ...template.card,
      id: crypto.randomUUID(),
      title,
      text: extractInnerHtmlFromText(text),
      label: label || template.card.label || "",
      linkText: linkText || template.card.linkText || "",
      link: typeof link === "string" ? {} : link,
      newTab: newTab,
      tabId,
      image,
      icon,
    };

    cards.push({ ...newCard });
  });

  const { columns, borderRadius, hasTabs } = oldData.config;
  const newConfig = {
    ...template.config,
    columns,
    borderRadius,
    hasTabs,
  };

  const cardsWithAdditionalData = cards.map((card) => ({
    card,
    config: { ...newConfig },
    tabs: oldData.tabs,
  }));

  return cardsWithAdditionalData;
};
